import type { Room } from "livekit-client";

const leaving = new WeakSet<Room>();
export const isLeavingGroupCall = (room: Room) => leaving.has(room);

// Stop capture synchronously, before removing the overlay. A pending device
// prompt also checks this marker before it can publish its eventual tracks.
export function disconnectGroupCall(room: Room) {
  leaving.add(room);
  for (const { track } of room.localParticipant.trackPublications.values())
    track?.stop();
  return room.disconnect();
}
